import { jsx } from "panel";
import { ModalEl, ModalType } from "common/components/modal";
import { IconSizeType } from "common/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { TextHighlightEl } from "common/components/text-highlight";
import { TEXT_HIGHLIGHT_THEME } from "common/components/text-highlight/types";
import { RevealableTextEditEl } from "common/components/revealable-text-editor";
import { ToggleEl } from "common/components/toggle/panel";
import { ToggleSize, ToggleTheme } from "common/components/toggle/types";
import { TooltipEl } from "common/components/tooltip";
import { userDetailsStore } from "common/report/stores/user-details";
import { capitalize } from "common/util/string";
import { AvatarUploadEl } from "common/widgets/avatar-upload";
import { UserIconEl } from "common/widgets/user-icon";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { TabOptions } from "./types";
function getReportRow({
  type,
  name,
  link
}, trackFn) {
  let icon = `brand-${type}`;
  if (type === `board`) {
    icon = `brand-dashboard`;
  }
  return /* @__PURE__ */ jsx("a", { sel: ".entry.report-entry.entry-title", attrs: {
    href: link
  }, on: {
    click: () => trackFn({
      type,
      name,
      link
    })
  }, "data-sentry-component": "getReportRow", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(null, null, name));
}
function getTeamRow({
  name
}) {
  return /* @__PURE__ */ jsx("div", { sel: ".entry", "data-sentry-component": "getTeamRow", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".entry-title.entry-content" }, name));
}
function LoadingSection() {
  return /* @__PURE__ */ jsx("div", { sel: ".loading-section", "data-sentry-component": "LoadingSection", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }));
}
function getReportContent(reports, trackFn) {
  var _a;
  if (!reports) {
    return LoadingSection();
  } else if (reports == null ? void 0 : reports.length) {
    return (_a = reports.filter((report) => !report.isHidden)) == null ? void 0 : _a.map((report) => getReportRow(report, trackFn));
  }
  return /* @__PURE__ */ jsx("div", { sel: ".entry", "data-sentry-component": "getReportContent", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".entry-content" }, "No recent reports or boards shared with you"));
}
function getTeamsContent(user) {
  var _a;
  if (!user) {
    return LoadingSection();
  } else if ((_a = user.teams) == null ? void 0 : _a.length) {
    return user.teams.map((team) => getTeamRow(team));
  }
  return /* @__PURE__ */ jsx("div", { sel: ".entry", "data-sentry-component": "getTeamsContent", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(null, null, "Not a member of any teams within this organization"));
}
function getTableSection(content) {
  return /* @__PURE__ */ jsx("div", { sel: ".info-container", "data-sentry-component": "getTableSection", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".table-section" }, content));
}
export function Template() {
  var _a, _b, _c, _d;
  const {
    selectedTab
  } = this.state;
  const bio = this.helpers.userIsMe() ? (_a = userDetailsStore.value) == null ? void 0 : _a.bio : (_b = this.state.user) == null ? void 0 : _b.bio;
  return /* @__PURE__ */ jsx("div", { sel: ".teammate-sidebar", "data-sentry-component": "Template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ModalEl, { attrs: {
    "modal-type": ModalType.RightDrawer,
    open: true,
    closeable: true,
    "hide-backdrop": true
  }, on: {
    change: this.helpers.handleModalChange
  }, "data-sentry-element": "ModalEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("div", { sel: ".top-section" }, this.helpers.userIsMe() ? /* @__PURE__ */ jsx(AvatarUploadEl, { params: {
    id: this.attr(`id`),
    hideName: true
  }, on: {
    avatarChanged: this.helpers.handleAvatarChanged
  } }) : /* @__PURE__ */ jsx(UserIconEl, { sel: ".icon", attrs: {
    "disable-sidebar": true,
    name: this.attr(`name`),
    id: this.attr(`id`),
    email: this.attr(`email`),
    size: IconSizeType.XL
  } }), /* @__PURE__ */ jsx("div", { sel: ".name" }, this.attr(`name`)), /* @__PURE__ */ jsx("div", { sel: ".email" }, this.attr(`email`)), this.state.user ? this.state.user.role && this.state.user.active ? /* @__PURE__ */ jsx(TextHighlightEl, { sel: ".role", theme: TEXT_HIGHLIGHT_THEME.INFORMATION, text: `Project ${capitalize((_c = this.state.user) == null ? void 0 : _c.role)}` }) : /* @__PURE__ */ jsx("span", null, /* @__PURE__ */ jsx(TextHighlightEl, { sel: ".role", theme: TEXT_HIGHLIGHT_THEME.LIGHT, text: `Inactive` }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: `User is no longer a member of the project`
  } })) : null, this.helpers.userIsMe() ? /* @__PURE__ */ jsx("div", { sel: ".bio" }, /* @__PURE__ */ jsx(RevealableTextEditEl, { attrs: {
    text: bio != null ? bio : ``
  }, on: {
    changedText: this.helpers.handleTextEditorSave
  } }, /* @__PURE__ */ jsx("div", { sel: ".bio-content", attrs: {
    slot: `content`
  }, class: {
    "existing-bio": !!bio
  } }, /* @__PURE__ */ jsx("div", { sel: ".text" }, bio || `Add a bio`), /* @__PURE__ */ jsx("div", { sel: ".btn-area" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".edit-bio-btn", attrs: {
    icon: `edit`,
    theme: ButtonTheme.Tertiary
  } }), bio && /* @__PURE__ */ jsx(ButtonEl, { sel: ".clear-bio-btn", attrs: {
    icon: `circle-clear`,
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.helpers.clearBio
  } }))))) : bio ? /* @__PURE__ */ jsx("div", { sel: ".bio" }, /* @__PURE__ */ jsx("div", { sel: ".text" }, bio)) : null, /* @__PURE__ */ jsx(ToggleEl, { sel: ".tab-toggle", elref: "tabToggle", onSelect: (value) => this.helpers.handleTabSelect(value), theme: ToggleTheme.TabBar, selected: selectedTab, size: ToggleSize.Medium, options: [{
    label: TabOptions.MostViewed,
    value: TabOptions.MostViewed
  }, {
    label: TabOptions.RecentlyCreated,
    value: TabOptions.RecentlyCreated
  }], "data-sentry-element": "ToggleEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".bottom-section" }, selectedTab === TabOptions.RecentlyCreated ? getTableSection(getReportContent((_d = this.state.user) == null ? void 0 : _d.recently_created, this.helpers.trackRecentlyCreated)) : selectedTab === TabOptions.MostViewed ? getTableSection(getReportContent(this.state.mostViewed, this.helpers.trackMostViewed)) : selectedTab === TabOptions.Teams ? getTableSection(getTeamsContent(this.state.user)) : null))));
}
